module.exports = __webpack_public_path__ + "img/menu-hair-7.e54d52a9.webp";